import { useState } from "react";
import { UserDetailModal } from "../../../UserDetailModal";
import * as styles from "./styles.css";

type Props = {
  userDetailFetchUrl: string;
  tableRowClassName?: string;
};

export const UserDetail = ({ userDetailFetchUrl, tableRowClassName }: Props) => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <tr>
      <td colSpan={6} className={`${tableRowClassName ?? ""} ${styles.content}`}>
        <button type="button" className={styles.toggleButton} onClick={handleOpenModal}>
          プロフィールの詳細を見る
        </button>
        {showModal && (
          <UserDetailModal
            fetchUrl={userDetailFetchUrl}
            handleOnClickClose={handleCloseModal}
            isShowScoutButton={false}
          />
        )}
      </td>
    </tr>
  );
};
